// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesSoftwareDependencyType = {
  SoftwareDependencyTypeComponent: 'component',
  SoftwareDependencyTypeLib: 'lib',
} as const;
export type AuratypesSoftwareDependencyType =
  (typeof AuratypesSoftwareDependencyType)[keyof typeof AuratypesSoftwareDependencyType];

export function instanceOfAuratypesSoftwareDependencyType(value: any): boolean {
  for (const key in AuratypesSoftwareDependencyType) {
    if (
      Object.prototype.hasOwnProperty.call(AuratypesSoftwareDependencyType, key)
    ) {
      if (
        AuratypesSoftwareDependencyType[
          key as keyof typeof AuratypesSoftwareDependencyType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesSoftwareDependencyTypeFromJSON(
  json: any,
): AuratypesSoftwareDependencyType {
  return AuratypesSoftwareDependencyTypeFromJSONTyped(json, false);
}

export function AuratypesSoftwareDependencyTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareDependencyType {
  return json as AuratypesSoftwareDependencyType;
}

export function AuratypesSoftwareDependencyTypeToJSON(
  value?: AuratypesSoftwareDependencyType | null,
): any {
  return value as any;
}

export function AuratypesSoftwareDependencyTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareDependencyType {
  return value as AuratypesSoftwareDependencyType;
}
